module.exports = __webpack_public_path__ + "img/logo_new.bd682832.jpg";